/*  MUI  */
import { Box, Button, Paper, Typography } from '@mui/material';

/*  Okta  */
import { withOktaAuth } from '@okta/okta-react';

/*  Shared  */
import { Logo } from 'application/Shared/Components/App';
import { URL } from 'application/Shared/Helpers';
import { debug } from 'application/Shared/Utils';

/*  Objects  */
import Session from 'objects/Session';

/*  React  */
import React, { PureComponent } from 'react';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'router/withRouter';

const goBack = () => {
    window.location.href = `${window.origin}/login`;
};

class Okta extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            err: false,
            popup: false
        };
    }

    componentDidMount() {
        this.load();
    }

    load = () => {
        const { location, oktaAuth, setSessionInfo } = this.props;

        const params = URL.getParams(location);
        const popup = params.has('popup');

        if (popup) {
            this.setState({ popup });
        }

        if (!oktaAuth) {
            const err = 'Error: invalid Okta configuration';
            debug.e(err, oktaAuth);
            this.setState({ err });
            return;
        }

        try {
            const options = {};

            // If there are any search params in the URL, include them in the state sent to Okta,
            // which will be returned as an encoded 'state' param in the Okta callback (see Okta/Callback component)
            const stringParams = params.toString();
            if (stringParams) {
                options.state = stringParams;
            }

            // End Session first in case there is an active session
            if (setSessionInfo) {
                setSessionInfo(null);
            }
            Session.end(async () => {
                oktaAuth.signInWithRedirect(options);
            });
        } catch (e) {
            const err = 'Unable to login';
            debug.e(e, err, oktaAuth);
            this.setState({ err });
        }
    };

    renderGoBack = () => {
        const { t } = this.props;
        const { popup } = this.state;

        if (popup) {
            return (
                <Button
                    data-trackid="login_okta_closePopup"
                    onClick={() => window.close()}
                    variant="outlined"
                    color="primary"
                >
                    {t('OAuth.close_popup')}
                </Button>
            );
        }

        return (
            <Button
                data-trackid="login_okta_returnToLogin"
                onClick={() => goBack()}
                variant="contained"
                color="secondary"
            >
                {t('OAuth.return_to_login')}
            </Button>
        );
    };

    render() {
        const { t } = this.props;
        const { err } = this.state;

        return (
            <Paper
                elevation={0}
                variant="outlined"
                style={{ height: '100%', padding: '24px' }}
            >
                <Box display="flex" flexDirection="column" alignItems="center">
                    <Box>
                        <Logo />
                    </Box>
                    <Box my="32px">
                        {err ? (
                            <>
                                <hr />
                                <Typography variant="h4">{err}</Typography>
                            </>
                        ) : (
                            <Typography
                                variant="h3"
                                sx={{ color: 'text.tertiary' }}
                            >
                                {t('OAuth.logging_in')}
                            </Typography>
                        )}
                    </Box>
                    <Box my="32px">{this.renderGoBack()}</Box>
                </Box>
            </Paper>
        );
    }
}

export default withRouter(withTranslation()(withOktaAuth(Okta)));
